import { mapActions, mapState } from 'vuex';
import leaderboardsInfo from '@/components/leaderboards/leaderboards-info/leaderboards-info.vue';
import publicProfileWidget from '@/components/profile/public-profile-widget/public-profile-widget.vue';
import socialLevelMixin from '@/mixins/socialLevel';
import loaderMixin from '@/mixins/loader';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  mixins: [
    loaderMixin,
    socialLevelMixin,
  ],
  components: {
    leaderboardsInfo,
    publicProfileWidget,
  },
  computed: {
    ...mapState('profile', ['userAffiliations', 'isUCAffilSet']),
  },
  methods: {
    ...mapActions('profile', ['getUserAffiliations']),
    ...mapActions('popup', [
      'setCurrentSmallPopup', 'setCurrentPopup', 'setCurrentPopupOptions',
    ]),
    showAffiliationsPopup() {
      this.setCurrentPopup(MODALS.AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_PUBLIC_PROFILE_INFO);
    },
  },
  mounted() {
    this.loaderAdd(document.body);
    this.getUserAffiliations()
      .then(() => this.loaderRemove(document.body))
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-dashboard-sushi/pages/sushi-leaderboard-info/sushi-leaderboard-info.js